'use strict';

(function () {
  'use strict';

  angular.module('vnext').config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('vnext.content.sleep', {
      url: 'sleep',
      abstract: true,
      default: '.main',
      template: '<ui-view />',
      data: {
        pageTitle: 'pageTitles.sleep'
      }
    }).state('vnext.content.sleep.main', {
      url: '',
      templateUrl: 'sleep/pages/sleep-main.html',
      abstract: true,
      default: '.plan',
      controller: 'SleepMainCtrl',
      controllerAs: 'vm'
    }).state('vnext.content.sleep.main.plan', {
      url: '/plan',
      templateUrl: 'sleep/pages/sleep-plan.html',
      controller: ['sleepScheduleSvc', function (sleepScheduleSvc) {
        var vm = this;
        vm.$onInit = function () {
          vm.pending = true;
          sleepScheduleSvc.getSchedule().then(function (schedule) {
            vm.pending = false;
            vm.schedule = schedule;
          });
        };
      }],
      controllerAs: 'vm'
    }).state('vnext.content.sleep.main.diary', {
      url: '/diary',
      templateUrl: 'sleep/pages/sleep-diary.html',
      controller: 'SleepDiaryCtrl',
      controllerAs: 'vm',
      resolve: {
        user: ['userSvc', function (userSvc) {
          return userSvc.getUser();
        }]
      }
    }).state('vnext.content.sleep.main.calendar', {
      url: '/calendar',
      template: '<ms-sleep-calendar latest-entry="vm.lastEntry" on-selected-day-change="vm.onUpdateDay(day);" />',
      controllerAs: 'vm',
      controller: ['$state', '$stateParams', '$log', 'lastEntry', function ($state, $stateParams, $log, lastEntry) {
        this.lastEntry = lastEntry;
        this.onUpdateDay = function (day) {
          $state.go('^.entry', { day: day });
        };
      }],
      resolve: {
        lastEntry: ['$state', function ($state) {
          return $state.params.day;
        }]
      }
    }).state('vnext.content.sleep.main.entry', {
      url: '/entry?day',
      templateUrl: 'sleep/pages/sleep-entry.html',
      params: {
        day: null
      },
      controller: ['$state', '$stateParams', '$translate', 'eventTrackingSvc', function ($state, $stateParams, $translate, eventTrackingSvc) {
        this.showCalendarOverlay = false;
        this.day = $stateParams.day;
        this.isOnboardingRoute = false;
        this.onUpdateDay = function (day) {
          $state.go('^.entry', { day: day });
        };
        this.entryComplete = function (data) {
          eventTrackingSvc.fireEvent('sleepTool', 'diaryEntry', 'diaryTool');
          $state.go('^.entry-summary', {
            day: $stateParams.day,
            entryData: data.entryData,
            requirements: data.requirements
          });
        };
      }],
      /** Load the route after all translations are ready */
      resolve: {
        translationReady: ['$translate', function ($translate) {
          return $translate.onReady(function () {
            return $translate('common.time.hour').then(function (res) {
              return res;
            });
          });
        }]
      },
      controllerAs: 'vm'
    }).state('vnext.content.sleep.main.entry-summary', {
      url: '/entry/summary?day',
      templateUrl: 'sleep/pages/sleep-entry-summary.html',
      params: {
        day: null,
        entryData: null,
        requirements: null
      },
      controller: 'SleepEntryDoneCtrl',
      controllerAs: 'vm'
    }).state('vnext.content.sleep.main.schedule', {
      url: '/schedule_check',
      template: '<ms-initial-sleep-schedule schedule="vm.schedule" on-complete="vm.continue()" />',
      controller: ['$state', 'schedule', function ($state, schedule) {
        var _this = this;

        this.$onInit = function () {
          _this.schedule = schedule;
        };

        this.continue = function () {
          $state.go('vnext.content.sleep.main.plan');
        };
      }],
      controllerAs: 'vm',
      params: {
        schedule: null
      },
      resolve: {
        schedule: ['$stateParams', 'sleepScheduleSvc', '$log', function ($stateParams, sleepScheduleSvc, $log) {
          return sleepScheduleSvc.getSchedule().then(function (schedule) {
            $log.debug('sleep schedule retrieved {}', schedule);
            return schedule;
          });
        }]
      }
    }).state('vnext.content.sleep.main.schedule-edit', {
      url: '/schedule',
      templateUrl: 'sleep/templates/sleep-schedule-edit.html',
      controller: 'SleepScheduleCtrl',
      controllerAs: 'vm',
      params: {
        schedule: null
      },
      resolve: {
        schedule: ['sleepScheduleSvc', '$log', function (sleepScheduleSvc, $log) {
          return sleepScheduleSvc.getSchedule().then(function (schedule) {
            $log.debug('sleep schedule retrieved {}', schedule);
            return schedule;
          });
        }]
      }
    }).state('vnext.content.sleep.print', {
      url: '/print',
      templateUrl: 'sleep/templates/print.html'
    });
  }]);
})();